import { RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B030040FindRequest = {
  seikyushimeYmd: string;
  seikyuCd: string;
  seikyushitenCd: string;
} & Partial<{
  tokuiCd: string;
  tokuishitenCd: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B030040FindResponse = {
  zenseikyuzanKin: string;
  konkainyuKin: string;
  kurikoshiKin: string;
  konkaiuriKin: string;
  henpinnebikiKin: string;
  zeiKbn: string;
  shohizeiGokeiKin: string;
  konkaiseikyuKin: string;
  urinyukinYmd: string;
  urinyukindenpyoNo: string;
  urinyukinKbn: string;
  uchiwakeNm: string;
  shohinCd: string;
  shohinNm: string;
  urisu: string;
  uritanka: string;
  uriKin: string;
  shohizeiKin: string;
  nyuKin: string;
  tokuiCd: string;
  tokuiNm: string;
};

export const B030040Find = (props: B030040FindRequest) => {
  return RestClient.get<PageableResponse<B030040FindResponse>>("b030040/find", {
    params: props,
  });
};

export type B030040GetSeikyuRequest = {
  tokuiCd: string;
  tokuishitenCd: string;
};

export type B030040GetSeikyuResponse = {
  tokuiCd: string;
  tokuishitenCd: string;
  seikyuKbn: string;
  seikyuNmr: string;
};

export const B030040GetSeikyu = (props: B030040GetSeikyuRequest) => {
  return RestClient.get<B030040GetSeikyuResponse>("b030040/get/seikyu", {
    params: props,
  });
};
